<template>
    <div class="b1t-okraina-page-loader" v-bind:class="!this.$store.state.isLoading ? 'done' : '' ">

        <div class="wrapper">
            <b1t-okraina-loader/>
        </div>

    </div>
</template>

<script>

    import b1tOkrainaLoader from '../okraina/loader'

    export default {
        name: 'b1t-okraina-page-loader',
        components: {
            b1tOkrainaLoader
        }
    }
</script>

<style lang="scss">

    .b1t-okraina-page-loader {
        position: fixed;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        z-index: 100;;
        background: #fff;

        transition: height 0s 0.3s, opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0s 0.3s, width 0s 0.3s;

        .wrapper {
            position: absolute;
            top: 50%;
            left: 50%;

            transform: translate(-50%,-50%);

        }
    }

    .b1t-okraina-page-loader.done {
        height: 0;
        opacity: 0;
        padding: 0;
        width: 0;
    }

</style>